define('model/historic.workflow.process.instance.model',['require','exports','module','underscore','./base.workflow.model'],function(require, exports, module) {
  //prettier-ignore
  var _                 = require('underscore'),
      BaseWorkflowModel = require('./base.workflow.model');

  var HistoricWorkflowProcessInstanceModel = BaseWorkflowModel.extend({
    urlRoot: '/api/v1/coi-workflow/runtime/historic-process-instances',
  });

  HistoricWorkflowProcessInstanceModel.QueryCollection = HistoricWorkflowProcessInstanceModel.Collection.extend({
    url: '/api/v1/coi-workflow/query/historic-process-instances',

    initialize: function() {
      HistoricWorkflowProcessInstanceModel.Collection.prototype.initialize.apply(this, arguments);

      this.requestBodyQueryModel = new Backbone.Model();
    },

    fetch: function(options) {
      return HistoricWorkflowProcessInstanceModel.Collection.prototype.fetch.call(
        this,
        _.extend({}, options, {
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(this.requestBodyQueryModel),
        })
      );
    },
  });

  module.exports = HistoricWorkflowProcessInstanceModel;
});

